import { useAutocompleteSource } from '@eas/common-web';
import { DictSenateAutocomplete } from '@models';
import { EvidenceApiUrl } from '@enums';

export function useSenates() {
  return useAutocompleteSource<DictSenateAutocomplete>({
    url: EvidenceApiUrl.DICT_SENATES + '/autocomplete',
  });
}
